import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "referral-report" };
const _hoisted_2 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" };
const _hoisted_3 = { class: "card-body p-15 p-sm-20 p-md-25" };
const _hoisted_4 = { class: "row align-items-end" };
const _hoisted_5 = { class: "col-lg-3 col-md-6 mb-3 mb-lg-0" };
const _hoisted_6 = { class: "form-label fw-medium text-black" };
const _hoisted_7 = { class: "col-lg-3 col-md-6 mb-3 mb-lg-0" };
const _hoisted_8 = { class: "form-label fw-medium text-black" };
const _hoisted_9 = { class: "col-lg-3 col-md-6 mb-3 mb-lg-0" };
const _hoisted_10 = { class: "form-label fw-medium text-black" };
const _hoisted_11 = { value: "" };
const _hoisted_12 = ["value"];
const _hoisted_13 = { class: "col-lg-3 col-md-6 text-lg-end" };
const _hoisted_14 = ["disabled"];
const _hoisted_15 = { class: "d-flex mb-20 gap-3" };
const _hoisted_16 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing overflow-hidden" };
const _hoisted_17 = { key: 0 };
const _hoisted_18 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" };
const _hoisted_19 = { class: "mb-0 fw-bold" };
const _hoisted_20 = { class: "search-box position-relative" };
const _hoisted_21 = ["placeholder"];
const _hoisted_22 = { class: "card-body p-0" };
const _hoisted_23 = { class: "table-responsive" };
const _hoisted_24 = { class: "table text-nowrap align-middle mb-0 custom-table" };
const _hoisted_25 = { key: 0 };
const _hoisted_26 = { key: 1 };
const _hoisted_27 = {
    colspan: "5",
    class: "text-center py-5 text-muted"
};
const _hoisted_28 = { class: "d-flex align-items-center" };
const _hoisted_29 = { class: "avatar-circle me-3" };
const _hoisted_30 = { class: "fw-bold d-block" };
const _hoisted_31 = { class: "text-muted" };
const _hoisted_32 = { class: "d-flex align-items-center" };
const _hoisted_33 = { class: "avatar-circle referee me-3" };
const _hoisted_34 = { class: "fw-bold d-block" };
const _hoisted_35 = { class: "text-muted" };
const _hoisted_36 = { class: "text-primary" };
const _hoisted_37 = { class: "d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 border-top" };
const _hoisted_38 = { class: "fs-13 text-muted" };
const _hoisted_39 = { "aria-label": "Page navigation" };
const _hoisted_40 = { class: "pagination pagination-sm mb-0" };
const _hoisted_41 = ["onClick"];
const _hoisted_42 = { key: 1 };
const _hoisted_43 = { class: "card-head box-shadow bg-white p-15 p-sm-20 p-md-25" };
const _hoisted_44 = { class: "mb-0 fw-bold text-gradient" };
const _hoisted_45 = { class: "text-muted small mb-0" };
const _hoisted_46 = { class: "card-body p-0" };
const _hoisted_47 = { class: "table-responsive" };
const _hoisted_48 = { class: "table text-nowrap align-middle mb-0 custom-table" };
const _hoisted_49 = { class: "text-center" };
const _hoisted_50 = { class: "text-center" };
const _hoisted_51 = { key: 0 };
const _hoisted_52 = { key: 1 };
const _hoisted_53 = {
    colspan: "5",
    class: "text-center py-5 text-muted"
};
const _hoisted_54 = { class: "text-center" };
const _hoisted_55 = { class: "d-flex align-items-center" };
const _hoisted_56 = { class: "avatar-circle me-3" };
const _hoisted_57 = { class: "fw-bold d-block" };
const _hoisted_58 = { class: "text-muted" };
const _hoisted_59 = { class: "text-center" };
const _hoisted_60 = { class: "fs-5 fw-bold text-dark" };
const _hoisted_61 = { class: "text-center" };
const _hoisted_62 = { class: "badge text-bg-primary fs-14 px-3 py-2 rounded-pill" };
const _hoisted_63 = { class: "text-primary" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('omnesightAi.startDate')), 1),
                        _withDirectives(_createElementVNode("input", {
                            type: "datetime-local",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.filters.startDate) = $event)),
                            class: "form-control shadow-none"
                        }, null, 512), [
                            [_vModelText, _ctx.filters.startDate]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('omnesightAi.endDate')), 1),
                        _withDirectives(_createElementVNode("input", {
                            type: "datetime-local",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.filters.endDate) = $event)),
                            class: "form-control shadow-none"
                        }, null, 512), [
                            [_vModelText, _ctx.filters.endDate]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('omnesightAi.selectRestaurant')), 1),
                        _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.filters.restaurantId) = $event)),
                            class: "form-select shadow-none"
                        }, [
                            _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.$t('omnesightAi.allRestaurants')), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.restaurants, (rest) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: rest.id,
                                    value: rest.id
                                }, _toDisplayString(rest.name), 9, _hoisted_12));
                            }), 128))
                        ], 512), [
                            [_vModelSelect, _ctx.filters.restaurantId]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("button", {
                            class: "btn btn-primary px-4 py-2",
                            onClick: _cache[3] || (_cache[3] =
                                //@ts-ignore
                                (...args) => (_ctx.fetchData && _ctx.fetchData(...args))),
                            disabled: _ctx.isLoading
                        }, [
                            _cache[11] || (_cache[11] = _createElementVNode("i", { class: "flaticon-refresh me-2" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('common.filter')), 1)
                        ], 8, _hoisted_14),
                        _createElementVNode("button", {
                            class: "btn btn-outline-secondary ms-2 px-4 py-2",
                            onClick: _cache[4] || (_cache[4] =
                                //@ts-ignore
                                (...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
                        }, _toDisplayString(_ctx.$t('common.reset')), 1)
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
                class: _normalizeClass(["tab-btn", { active: _ctx.activeTab === 'all' }]),
                onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.activeTab = 'all'))
            }, [
                _cache[12] || (_cache[12] = _createElementVNode("i", { class: "flaticon-users-1 me-2" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('sidebar.referral')), 1)
            ], 2),
            _createElementVNode("button", {
                class: _normalizeClass(["tab-btn", { active: _ctx.activeTab === 'top' }]),
                onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.activeTab = 'top'))
            }, [
                _cache[13] || (_cache[13] = _createElementVNode("i", { class: "flaticon-star me-2" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('loyalty.topReferrers')), 1)
            ], 2)
        ]),
        _createElementVNode("div", _hoisted_16, [
            (_ctx.activeTab === 'all')
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("h5", _hoisted_19, _toDisplayString(_ctx.$t('loyalty.referralReport')), 1),
                        _createElementVNode("div", _hoisted_20, [
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.filters.search) = $event)),
                                type: "text",
                                class: "form-control shadow-none text-black rounded-0 border-0 border-bottom",
                                placeholder: _ctx.$t('loyalty.searchReferral'),
                                onInput: _cache[8] || (_cache[8] =
                                    //@ts-ignore
                                    (...args) => (_ctx.onSearchInput && _ctx.onSearchInput(...args)))
                            }, null, 40, _hoisted_21), [
                                [_vModelText, _ctx.filters.search]
                            ]),
                            _cache[14] || (_cache[14] = _createElementVNode("i", { class: "flaticon-search-interface-symbol position-absolute end-0 top-50 translate-middle-y me-2 text-primary" }, null, -1))
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("table", _hoisted_24, [
                                _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('loyalty.referrer')), 1),
                                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('loyalty.referee')), 1),
                                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('loyalty.referralDate')), 1),
                                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('loyalty.pointsEarned')), 1),
                                        _cache[15] || (_cache[15] = _createElementVNode("th", null, "Campaing Code", -1))
                                    ])
                                ]),
                                _createElementVNode("tbody", null, [
                                    (_ctx.isLoading)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [...(_cache[16] || (_cache[16] = [
                                                _createElementVNode("td", {
                                                    colspan: "5",
                                                    class: "text-center py-5"
                                                }, [
                                                    _createElementVNode("div", {
                                                        class: "spinner-border text-primary",
                                                        role: "status"
                                                    })
                                                ], -1)
                                            ]))]))
                                        : (_ctx.referrals.length === 0)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [
                                                _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.$t('loyalty.noReferrals')), 1)
                                            ]))
                                            : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referrals, (item) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                            key: item.refereeId
                                        }, [
                                            _createElementVNode("td", null, [
                                                _createElementVNode("div", _hoisted_28, [
                                                    _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.getInitials(item.referrerFirstName, item.referrerLastName)), 1),
                                                    _createElementVNode("div", null, [
                                                        _createElementVNode("span", _hoisted_30, _toDisplayString(item.referrerFirstName) + " " + _toDisplayString(item.referrerLastName), 1),
                                                        _createElementVNode("small", _hoisted_31, _toDisplayString(item.referrerEmail), 1)
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("td", null, [
                                                _createElementVNode("div", _hoisted_32, [
                                                    _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.getInitials(item.refereeFirstName, item.refereeLastName)), 1),
                                                    _createElementVNode("div", null, [
                                                        _createElementVNode("span", _hoisted_34, _toDisplayString(item.refereeFirstName) + " " + _toDisplayString(item.refereeLastName), 1),
                                                        _createElementVNode("small", _hoisted_35, _toDisplayString(item.refereeEmail), 1)
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(item.referralDate)), 1),
                                            _createElementVNode("td", null, [
                                                _createElementVNode("span", {
                                                    class: _normalizeClass(['badge', item.pointsEarned > 0 ? 'text-bg-success' : 'text-bg-secondary'])
                                                }, _toDisplayString(item.pointsEarned) + " pts ", 3)
                                            ]),
                                            _createElementVNode("td", null, [
                                                _createElementVNode("code", _hoisted_36, _toDisplayString(item.referralCode), 1)
                                            ])
                                        ]));
                                    }), 128))
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("span", _hoisted_38, " Showing " + _toDisplayString(((_ctx.pagination.page - 1) * _ctx.pagination.limit) + 1) + " to " + _toDisplayString(Math.min(_ctx.pagination.page * _ctx.pagination.limit, _ctx.pagination.total)) + " of " + _toDisplayString(_ctx.pagination.total) + " entries ", 1),
                            _createElementVNode("nav", _hoisted_39, [
                                _createElementVNode("ul", _hoisted_40, [
                                    _createElementVNode("li", {
                                        class: _normalizeClass(["page-item", { disabled: _ctx.pagination.page === 1 }])
                                    }, [
                                        _createElementVNode("button", {
                                            class: "page-link",
                                            onClick: _cache[9] || (_cache[9] = ($event) => (_ctx.changePage(_ctx.pagination.page - 1)))
                                        }, _toDisplayString(_ctx.$t('common.previous')), 1)
                                    ], 2),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagination.totalPages, (p) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                            key: p,
                                            class: _normalizeClass(["page-item", { active: p === _ctx.pagination.page }])
                                        }, [
                                            _createElementVNode("button", {
                                                class: "page-link",
                                                onClick: ($event) => (_ctx.changePage(p))
                                            }, _toDisplayString(p), 9, _hoisted_41)
                                        ], 2));
                                    }), 128)),
                                    _createElementVNode("li", {
                                        class: _normalizeClass(["page-item", { disabled: _ctx.pagination.page === _ctx.pagination.totalPages }])
                                    }, [
                                        _createElementVNode("button", {
                                            class: "page-link",
                                            onClick: _cache[10] || (_cache[10] = ($event) => (_ctx.changePage(_ctx.pagination.page + 1)))
                                        }, _toDisplayString(_ctx.$t('common.next')), 1)
                                    ], 2)
                                ])
                            ])
                        ])
                    ])
                ]))
                : (_ctx.activeTab === 'top')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("h5", _hoisted_44, _toDisplayString(_ctx.$t('loyalty.topReferrers')), 1),
                            _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.$t('loyalty.totalReferralsInRange')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, [
                                _createElementVNode("table", _hoisted_48, [
                                    _createElementVNode("thead", null, [
                                        _createElementVNode("tr", null, [
                                            _cache[17] || (_cache[17] = _createElementVNode("th", { width: "100" }, "Rank", -1)),
                                            _createElementVNode("th", null, _toDisplayString(_ctx.$t('loyalty.referrer')), 1),
                                            _createElementVNode("th", _hoisted_49, _toDisplayString(_ctx.$t('loyalty.totalReferrals')), 1),
                                            _createElementVNode("th", _hoisted_50, _toDisplayString(_ctx.$t('loyalty.totalPoints')), 1),
                                            _cache[18] || (_cache[18] = _createElementVNode("th", null, "Referral Code", -1))
                                        ])
                                    ]),
                                    _createElementVNode("tbody", null, [
                                        (_ctx.isLoadingTop)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_51, [...(_cache[19] || (_cache[19] = [
                                                    _createElementVNode("td", {
                                                        colspan: "5",
                                                        class: "text-center py-5"
                                                    }, [
                                                        _createElementVNode("div", {
                                                            class: "spinner-border text-primary",
                                                            role: "status"
                                                        })
                                                    ], -1)
                                                ]))]))
                                            : (_ctx.topReferrers.length === 0)
                                                ? (_openBlock(), _createElementBlock("tr", _hoisted_52, [
                                                    _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.$t('loyalty.noReferrals')), 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topReferrers, (item, index) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                                key: item.referrerId
                                            }, [
                                                _createElementVNode("td", _hoisted_54, [
                                                    _createElementVNode("div", {
                                                        class: _normalizeClass(['rank-badge', `rank-${index + 1}`])
                                                    }, _toDisplayString(index + 1), 3)
                                                ]),
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("div", _hoisted_55, [
                                                        _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.getInitials(item.firstName, item.lastName)), 1),
                                                        _createElementVNode("div", null, [
                                                            _createElementVNode("span", _hoisted_57, _toDisplayString(item.firstName) + " " + _toDisplayString(item.lastName), 1),
                                                            _createElementVNode("small", _hoisted_58, _toDisplayString(item.email), 1)
                                                        ])
                                                    ])
                                                ]),
                                                _createElementVNode("td", _hoisted_59, [
                                                    _createElementVNode("span", _hoisted_60, _toDisplayString(item.referralCount), 1)
                                                ]),
                                                _createElementVNode("td", _hoisted_61, [
                                                    _createElementVNode("span", _hoisted_62, _toDisplayString(item.totalPointsEarned) + " pts ", 1)
                                                ]),
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("code", _hoisted_63, _toDisplayString(item.referralCode), 1)
                                                ])
                                            ]));
                                        }), 128))
                                    ])
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true)
        ])
    ]));
}
